import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import { useAuth } from './context/AuthContext';

// Layout Components
import Layout from './components/Layout/Layout';
import PublicLayout from './components/Layout/PublicLayout';

// Page Components - Restore all essential features
import Home from './pages/Home';
import Login from './pages/Login';
import Register from './pages/Register';
import Dashboard from './pages/Dashboard';
import DailyCheckin from './pages/DailyCheckin';
import OrganHealth from './pages/OrganHealth';
import OrganHealthResults from './pages/OrganHealthResults';
import DynamicQuestionnaire from './pages/DynamicQuestionnaire';
import QuestionnaireList from './pages/QuestionnaireList';
import Reports from './pages/Reports';
import Leaderboard from './pages/Leaderboard';
import Analytics from './pages/Analytics';
import Chatbot from './pages/Chatbot';
import Feedback from './pages/Feedback';
import AboutUs from './pages/AboutUs';
import VirtualTwin from './pages/VirtualTwin';
import Profile from './pages/Profile';

// Loading Component
import LoadingSpinner from './components/UI/LoadingSpinner';

// Protected Route Component
const ProtectedRoute = ({ children }) => {
  const { user, loading } = useAuth();
  
  if (loading) {
    return <LoadingSpinner />;
  }
  
  return user ? children : <Navigate to="/login" replace />;
};

// Public Route Component (redirect if authenticated)
const PublicRoute = ({ children }) => {
  const { user, loading } = useAuth();
  
  if (loading) {
    return <LoadingSpinner />;
  }
  
  return !user ? children : <Navigate to="/dashboard" replace />;
};

function App() {
  return (
    <div className="App">
      <Routes>
        {/* Public Routes */}
        <Route path="/" element={<PublicLayout />}>
          <Route index element={<Home />} />
          <Route 
            path="login" 
            element={
              <PublicRoute>
                <Login />
              </PublicRoute>
            } 
          />
          <Route 
            path="register" 
            element={
              <PublicRoute>
                <Register />
              </PublicRoute>
            } 
          />
        </Route>

        {/* Protected Routes */}
        <Route 
          path="/" 
          element={
            <ProtectedRoute>
              <Layout />
            </ProtectedRoute>
          }
        >
          <Route path="dashboard" element={<Dashboard />} />
          <Route path="checkin" element={<DailyCheckin />} />
          <Route path="organ-health" element={<OrganHealth />} />
          <Route path="organ-health-results" element={<OrganHealthResults />} />
          <Route path="questionnaire" element={<QuestionnaireList />} />
          <Route path="dynamic-questionnaire" element={<DynamicQuestionnaire />} />
          <Route path="dynamic-questionnaire/:type" element={<DynamicQuestionnaire />} />
          <Route path="reports" element={<Reports />} />
          <Route path="analytics" element={<Analytics />} />
          <Route path="leaderboard" element={<Leaderboard />} />
          <Route path="virtual-twin" element={<VirtualTwin />} />
          <Route path="chatbot" element={<Chatbot />} />
          <Route path="feedback" element={<Feedback />} />
          <Route path="about" element={<AboutUs />} />
          <Route path="profile" element={<Profile />} />
        </Route>

        {/* Catch all route */}
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </div>
  );
}

export default App;
